import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#form" }),
    /*#__PURE__*/_createTextVNode(" Form ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
    /*#__PURE__*/_createTextVNode(" Form consists of "),
    /*#__PURE__*/_createVNode("code", null, "input"),
    /*#__PURE__*/_createTextVNode(", "),
    /*#__PURE__*/_createVNode("code", null, "radio"),
    /*#__PURE__*/_createTextVNode(", "),
    /*#__PURE__*/_createVNode("code", null, "select"),
    /*#__PURE__*/_createTextVNode(", "),
    /*#__PURE__*/_createVNode("code", null, "checkbox"),
    /*#__PURE__*/_createTextVNode(" and so on. With form, you can collect, verify and submit data. ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicForm = _resolveComponent("EUIBasicForm")
  const _component_EUIInlineForm = _resolveComponent("EUIInlineForm")
  const _component_EUIAlignment = _resolveComponent("EUIAlignment")
  const _component_EUIValidation = _resolveComponent("EUIValidation")
  const _component_EUICustomValidationRules = _resolveComponent("EUICustomValidationRules")
  const _component_EUIDeleteOrAddFormItemsDynamically = _resolveComponent("EUIDeleteOrAddFormItemsDynamically")
  const _component_EUINumberValidate = _resolveComponent("EUINumberValidate")
  const _component_EUISizeControl = _resolveComponent("EUISizeControl")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicForm),
    _createVNode(_component_EUIInlineForm),
    _createVNode(_component_EUIAlignment),
    _createVNode(_component_EUIValidation),
    _createVNode(_component_EUICustomValidationRules),
    _createVNode(_component_EUIDeleteOrAddFormItemsDynamically),
    _createVNode(_component_EUINumberValidate),
    _createVNode(_component_EUISizeControl)
  ], 64))
}